module.exports = __webpack_public_path__ + "img/건강노화힐링산업_old.8abd0970.png";